(function() {
    'use strict';

    angular
        .module('elogbooks.common.actions')
        .controller('CommonActionDetailsController', CommonActionDetailsController);

    CommonActionDetailsController.$inject = [
        'actionResponse',
        'config',
        'modulesService'
    ];

    function CommonActionDetailsController(
        actionResponse,
        config,
        modulesService
    ) {
        var vm = this;
        vm.actionResponse = actionResponse;
        vm.config = config;
        vm.actionType = actionResponse?.getLinkAttribute('actiontype', 'title');
        vm.assetsModuleEnabled = modulesService.isEnabled('assets_module');
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');

        if (actionResponse?.getLinkAttribute('actiontype', 'systemType') === 3 &&
            !modulesService.getEnabled('audits_module_enabled')) {
            vm.actionType = null;
        }

        vm.fromJobCompletedAt = actionResponse.getLinkAttribute('from-job', 'completedAt');

        angular.extend(vm.actionResponse, vm.config);
    }
})();
